import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const PortugalLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'PT',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Portugal',
  SHORT_NAME: 'PT',

  DISPLAY_NAME: 'Portugal (English)',
  DISPLAY_COUNTRY: 'Portugal (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 35.9915752,
    INITIAL_LONGITUDE: -18.8269796,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Açores',
    '2': 'Aveiro',
    '3': 'Beja',
    '4': 'Braga',
    '5': 'Bragança',
    '6': 'Castelo Branco',
    '7': 'Coimbra',
    '8': 'Évora',
    '9': 'Faro',
    '10': 'Guarda',
    '11': 'Leiria',
    '12': 'Lisboa',
    '13': 'Madeira',
    '14': 'Portalegre',
    '15': 'Porto',
    '16': 'Santarém',
    '17': 'Setúbal',
    '18': 'Viana do Castelo',
    '19': 'Vila Real',
    '20': 'Viseu',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-pt/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-pt/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}-[0-9]{3}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default PortugalLocale
